export const isBuildPlatformApp = import.meta.env.VITE_BUILD_PLATFORM === 'app'
export const isBuildPlatformWeb = import.meta.env.VITE_BUILD_PLATFORM === 'web'
